import { EntityManagerFieldInfos } from '@record-it-npm/synchro-client';
import { createUserEntityInfo } from 'record-it-time-common/entity/entities/User/createUserEntityInfo';
import { AppSynchronizationEnvironmentTypes } from '../../../AppSynchronizationEnvironmentTypes';
import { User } from './userTypes';
export const userEntityInfo = createUserEntityInfo<User>({
  additionalFieldInfos: EntityManagerFieldInfos.createAdditionalFieldInfos<AppSynchronizationEnvironmentTypes>()
});